// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelMiniProgramSetting-Components-StatusTag-css-module__statusTag--v7Oxv"};